var React = require('react');

function PlusBoxInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0}),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":1},[React.createElement("path",{"fill":"#E1E1E1","d":"M12 10h2v6h-2z","key":0}),React.createElement("path",{"fill":"#E1E1E1","d":"M16 12v2h-6v-2z","key":1}),React.createElement("path",{"stroke":"#E1E1E1","d":"M.5.5h25v25H.5z","key":2}),React.createElement("path",{"fill":"#D8D8D8","d":"M7.072 7.05h5l-5 5zM7.072 19.05v-5l5 5zM19.072 19.05h-5l5-5zM19.072 7.05v5l-5-5z","key":3})])]);
}

PlusBoxInline.defaultProps = {"width":"26","height":"26"};

module.exports = PlusBoxInline;

PlusBoxInline.default = PlusBoxInline;
